import { SpectrumGenerator } from 'spectrum-generator';
const defaultPeakShape = {
    kind: 'gaussian',
    fwhm: 4,
};
/**
 * Generate 1D chromatographic data from a list of peaks.
 * @param peaks - The list of peaks to include in the chromatogram.
 * @param options - Information about the chromatographic range to generate.
 * @returns The generated chromatographic data (times and intensities).
 */
export function generateChromatogram1D(peaks, options) {
    const nbPoints = Math.round((options.lastTime - options.firstTime) * options.scansPerTime) +
        1;
    const generator = new SpectrumGenerator({
        from: options.firstTime,
        to: options.lastTime,
        nbPoints,
    });
    const generatorPeaks = peaks.map((peak) => {
        return {
            x: peak.retentionTime,
            y: peak.intensity,
            shape: peak.shape ?? defaultPeakShape,
        };
    });
    generator.addPeaks(generatorPeaks);
    const data = generator.getSpectrum();
    return {
        times: data.x,
        intensities: data.y,
    };
}
//# sourceMappingURL=generate_chromatogram_1d.js.map